import { UserCircleMinus } from "@phosphor-icons/react";

import FilterButton from "common/components/ui/FilterButton";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectItemText,
  SelectTrigger,
  SelectValue,
} from "common/components/ui/Select";

import CampaignPausedTooltip from "../CampaignPausedTooltip";
import SectionHeading from "./SectionHeading";

const withdrawConnectionOptions: { label: string; value: string }[] = [];
for (let i = 1; i <= 30; i += 1) {
  withdrawConnectionOptions.push({
    label: `${i} ${i === 1 ? "day" : "days"}`,
    value: (i * 1000 * 60 * 60 * 24).toString(),
  });
}
export default function WithdrawConnection({
  delay,
  setDelay,
  isDisabled,
}: {
  delay: number;
  setDelay: (delay: number) => void;
  isDisabled: boolean;
}) {
  return (
    <div className="flex flex-col gap-3 lg:flex-row lg:items-center">
      <div className="flex flex-1 items-center justify-between gap-3">
        <SectionHeading
          title="Withdraw connection request"
          description="Automatically withdraw your connection request after a certain time"
          icon={<UserCircleMinus />}
          shouldShowMobileTooltip
        />
      </div>

      <Select
        value={delay.toString()}
        onValueChange={(value) => setDelay(Number(value))}
        disabled={isDisabled}
      >
        <CampaignPausedTooltip isEditingDisabled={isDisabled}>
          <SelectTrigger className="lg:w-40" asChild>
            <FilterButton>
              <SelectValue />
            </FilterButton>
          </SelectTrigger>
        </CampaignPausedTooltip>
        <SelectContent>
          {withdrawConnectionOptions.map(({ value, label }) => (
            <SelectItem value={value.toString()} key={value}>
              <SelectItemText>{label}</SelectItemText>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
